import './styles.css';

import React from 'react';
import { Dropdown, Typography } from '@vtblife/uikit';
import Icon from '@vtblife/uikit-icons';
import Tooltip from '@search/vtbeco-ui/src/components/controls/Tooltip';
import classname from '@search/classname/src';

import { OfferRoute } from '../../../../domain/offer/search/page/SearchOffersQuery';
import { OfferRouteCard } from '../OfferRouteCard';

const cn = classname.bind(null, 'OfferRoutePopupList');

interface IOfferRoutesList {
    offerRoutes: OfferRoute[];
    className?: string;
    isClSnippet?: boolean;
}

export const OfferRoutePopupList = ({ offerRoutes, className, isClSnippet }: IOfferRoutesList) => {
    return ! isClSnippet ? (
        <Tooltip
            size='l'
            directions={[ 'bottom-center' ]}
            renderContent={() => (
                <div>
                    {offerRoutes.map(offerRoute => <OfferRouteCard
                        key={offerRoute.metro.id}
                        offerRoute={offerRoute}
                    />)}
                </div>
            )}
            renderTrigger={({ handleToggle, triggerRef }) => (
                <button
                    ref={triggerRef}
                    onClick={handleToggle}
                    className={cn('button', undefined, className)}
                >
                    <div className={cn('clNew')}>
                        <Typography
                            variant='secondary-alone'
                            color='secondary'
                        >
                            Ещё {offerRoutes.length}
                        </Typography>
                        <Icon name='chevron-down' size='xs' />
                    </div>
                </button>
            )}
        />
    ) :
        (
            <div className={cn('clNew')}>
                <Dropdown>
                    <Dropdown.Control arrow>
                        <Typography
                            variant='primary-alone'
                            color='secondary'
                        >
                            Ещё {offerRoutes.length}
                        </Typography>
                    </Dropdown.Control>
                    <Dropdown.Content>
                        <div>
                            {offerRoutes.map(offerRoute => <OfferRouteCard
                                key={offerRoute.metro.id}
                                offerRoute={offerRoute}
                            />)}
                        </div>
                    </Dropdown.Content>
                </Dropdown>
            </div>
        );
};
